import { ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';

export const fieldSchema: ISchemaFields = ({ formProps }) => {
  const { intl } = formProps || {};
  return {
    code: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'equipment.code' }),
      placeholder: intl.formatMessage({ id: 'equipment.codeEnter' }),
      propsWrapper: { xs: 6 },
      register: {
        required: true,
      },
    },
    name: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'equipment.name' }),
      placeholder: intl.formatMessage({ id: 'equipment.nameEnter' }),
      propsWrapper: { xs: 6 },
      register: {
        required: true,
      },
    },
  };
};

const ui: IUiFields = ({ formProps }) => {
  return [
    {
      id: 'info',
      fields: ['code', 'name'],
    },
  ];
};

export const equipmentFormSchema: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
};
